import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import './chatLandingSupportGrid.scss';
import Hidden from "@material-ui/core/Hidden";
import Link from '@material-ui/core/Link';
import {Accessibility,Account,LocateStore,Move,StatusCenter} from "./chatLandingSupportGridIcons";

export default class ChatLandingSupportGrid extends Component{

    constructor(props) {
        super(props);
        this.state = {
            innerWidth: 0,
            screenWidth: 0
        };

        this.detect = this.detect.bind(this);
        this.onGridKeyClicked = this.onGridKeyClicked.bind(this);
    }
    renderImages(card,height,padding,width) {
        switch (card.icon) {
            case "Accessibility":
                return <Accessibility height={height} padding={padding} width={width}/>
            case "Account":
                return <Account height='33' padding={padding}/>
            case "LocateStore":
                return <LocateStore height={height} padding={padding} width={width}/>
            case "Move":
                return <Move  height={height} padding={padding} width={width}/>
            case "StatusCenter":
                return <StatusCenter  height={height} padding={padding} width={width}/>

        }
    }

    detect()
        {
            //console.log(screen.orientation.angle);
            this.setState({innerWidth: window.innerWidth, screenWidth :window.screen.availWidth});

        }

    componentDidMount() {

        window.addEventListener('resize', this.detect);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.detect);
      //  window.removeEventListener("orientationchange", this.detect);

    }

    onGridKeyClicked(event,link)
    {
       // console.log("coming here at onGridKeyClicked");

        if (event.keyCode === 13) {
            event.preventDefault();






            let isIE = !!navigator.userAgent.match(/Trident/g) ||!!navigator.userAgent.match(/Edge/g)|| !!navigator.userAgent.match(/MSIE/g);
            if (isIE > 0) {

                window.open(link,'_blank');

            } else {

                window.open(link, '_self');
            }

        }
    }



    render(){

        return <Grid container
                     direction="row"
                     justify="center"
                     className={'chatLanding-support-grid-container'}
                     alignItems="center">
            <Grid item xs={12} className={'chatLanding-support-grid'}>
                <Hidden xsDown>
                <h3  role='text' aria-label={this.props.cardsSupport.cardHeading} tabIndex='-1' className='chatLanding-support-grid-title'>{this.props.cardsSupport.cardHeading}</h3>
                </Hidden>
                <Hidden smUp>
                    <h3  role='text' aria-label={this.props.cardsSupport.cardHeading} tabIndex='-1' className='chatLanding-support-grid-title-small'>{this.props.cardsSupport.cardHeading}</h3>
                </Hidden>
                <Grid container
                      data-tracking='{"container":["xa-chat-support-cards"]}'
                      direction="row"
                      justify="center"
                      alignItems="stretch">
                    {this.props.cardsSupport.cardsAdditional.map((item, index)=> {
                        let  mediumCardContainer ='chatLanding-support-item-grid-container';

                       let gridWidth = index < 3 ? 4 : 6;
                      let  screenWidth=this.state.screenWidth;
                      if(screenWidth===0){screenWidth=window.screen.availWidth;}
                        if((screenWidth!= undefined) && (screenWidth!=null) )
                        {
                            if (screenWidth == 768 || screenWidth == 748 || screenWidth == 601) {
                                gridWidth=6;
                            }
                        }



                       /* if(this.props.cardsSupport.cardsAdditional.length%3 ===2)
                        {
                            console.log('we have odd cards here ***********************');
                            //Find the last 2 indexes in that cases
                            if(index+1===this.props.cardsSupport.cardsAdditional.length-1)
                            {
                                //console.log('we have here the card before last card whose index is '+index);
                               // mediumCardContainer='chatLanding-support-item-last-grid-container';

                            }
                            if(index===this.props.cardsSupport.cardsAdditional.length-1)
                            {
                               // console.log('we have here the last card whose index is '+index);
                               // mediumCardContainer='chatLanding-support-item-last-grid-container';
                            }
                        }*/

                        return (<Grid key={index} onKeyDown={(event)=>{this.onGridKeyClicked(event,item.link)}}  item sm={gridWidth} md={4} xs={12} className={mediumCardContainer}>
                            <Paper className='item'>
                                {this.renderImages(item,36,27,40)}
                                <br/><span tabIndex='-1' className={'chatLanding-support-item-grid-title'}>{item.title}</span>
                                <br/><span tabIndex='-1' className={'chatLanding-support-item-grid-description'}>{item.description}</span>
                                <br/><Link  data-tracking role='presentation' aria-label={item.linkText} tabIndex='0' href={item.link} className={'chatLanding-support-item-grid-link'} >{item.linkText}</Link>
                            </Paper>
                        </Grid>);
                    })}
                </Grid>
            </Grid>
        </Grid>
    }

}
